import React, {Component} from 'react';
import {connect} from "react-redux";

import classNames from "classnames";
import emailValidator from "email-validator";

import {sendConfigurationEmail} from "../../helpers/common";

import Modal from "../Modal";
import Loader from "../Loader";

import styles from './index.module.scss';

class ConfigEmailModal extends Component {

  constructor(props, context) {

    super(props, context);

    this.emailRef = React.createRef();

    this.deafaultState = {
      invalidEmail: false,
      sending: false,
      error: false,
      wasSent: false
    };

    this.state = this.deafaultState;

  }


  closeEmailPopup = () => {

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }

    if (this.state.wasSent || this.state.error) {
      this.setState(this.deafaultState)
    }

  };

  onChangeInput = (e) => {
    if (this.state.invalidEmail && emailValidator.validate(e.target.value)) {
      this.setState({
        invalidEmail: false
      });
    }
  };

  sendConfigurationEmail = async () => {

    const email = this.emailRef.current.value;
    let params = this.props.params;

    if (!emailValidator.validate(email)) {

      this.setState({
        invalidEmail: true
      });

      return;

    }

    this.setState({
      sending: true
    });

    try {

      await sendConfigurationEmail(email, params);

      this.setState({
        wasSent: true
      });

    } catch (e) {

      this.setState({
        error: true
      });

    } finally {

      this.setState({
        sending: false
      });

    }

  };

  render() {
    const {invalidEmail, sending, error, wasSent} = this.state;
    const {open} = this.props;

    return (
      <Modal
        isOpen={open}
        onRequestClose={this.closeEmailPopup}
        className={styles['modal']}
      >

        {error !== false &&
        <p>Sending Error</p>
        }

        {sending !== false &&
        <Loader/>
        }

        {error === false && sending === false && wasSent === false &&
        <React.Fragment>
          <h2 className={styles['heading']}>Tischkonfiguration speichern.</h2>
          <div className={styles['subheading']}>Wir senden dir einen Link per E-Mail zu, damit du jederzeit auf deinen
            Tisch zugreifen kannst.
          </div>

          <input
            type="text"
            placeholder="E-Mail-Adresse"
            ref={this.emailRef}
            onChange={this.onChangeInput}
            className={classNames(styles['input'], {
              [styles['input--invalid']]: invalidEmail
            })}
          />

          <button onClick={this.sendConfigurationEmail} className={styles['button']}>Konfiguration zuschicken</button>
          <div className={styles['notice']}>Mit Klick auf den Button akzeptierst du unsere Datenschutzbedingungen.</div>
        </React.Fragment>
        }

        {wasSent === true &&
        <p className={styles['was-sent-message']}>
          Vielen Dank. Wir haben dir deine Konfiguration per E-Mail geschickt.
        </p>
        }

      </Modal>
    );
  }

}

export default connect(
  state => ({
    params: state.params
  })
)(ConfigEmailModal);
